import { render, staticRenderFns } from "./ClientDeliveryAddressPopup.vue?vue&type=template&id=b27917d4&scoped=true&"
import script from "./ClientDeliveryAddressPopup.vue?vue&type=script&lang=js&"
export * from "./ClientDeliveryAddressPopup.vue?vue&type=script&lang=js&"
import style0 from "./ClientDeliveryAddressPopup.vue?vue&type=style&index=0&id=b27917d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27917d4",
  null
  
)

export default component.exports